import { render, staticRenderFns } from "./LaoPuCDialogSurvey.vue?vue&type=template&id=1b366e2c&scoped=true"
import script from "./LaoPuCDialogSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./LaoPuCDialogSurvey.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LaoPuCDialogSurvey.vue?vue&type=style&index=0&id=1b366e2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b366e2c",
  null
  
)

export default component.exports